import { useCallback, useState } from "react";
import { SimSidebar, SimsEmptyState } from "./components/SimSidebar.jsx";
import { SimDetailPanel } from "./components/SimDetailPanel.jsx";
import { CreateSimModal } from "./components/CreateSimModal.jsx";

export function SimManager({
  items,
  allItems,
  simTypes,
  selectedSimType,
  loading,
  search,
  setSearch,
  selected,
  selectedId,
  setSelectedId,
  addSim,
  saveSim,
  removeSim,
  saving,
  emptyHint,
}) {
  const [modalOpen, setModalOpen] = useState(false);
  const [editing, setEditing] = useState(null);

  const openCreate = useCallback(() => {
    setEditing(null);
    setModalOpen(true);
  }, []);

  const openEdit = useCallback((sim) => {
    setEditing(sim);
    setModalOpen(true);
  }, []);

  const closeModal = useCallback(() => {
    setModalOpen(false);
    setEditing(null);
  }, []);

  const handleSave = useCallback(async (payload) => {
    if (editing) {
      await saveSim(editing.id, payload);
    } else {
      await addSim(payload);
    }
  }, [editing, saveSim, addSim]);

  const showEmpty = !loading && allItems.length === 0;

  return (
    <>
      <div style={{ display: "flex", flex: 1, minHeight: 0, height: "100%" }}>
        <SimSidebar sims={items} selectedId={selectedId} onSelect={setSelectedId} search={search} onSearchChange={setSearch} onCreate={openCreate} loading={loading} />
        {showEmpty ? (
          <SimsEmptyState onCreate={openCreate} hint={emptyHint} />
        ) : (
          <SimDetailPanel sim={selected} simType={selectedSimType} onEdit={openEdit} onDelete={removeSim} />
        )}
      </div>
      <CreateSimModal open={modalOpen} onClose={closeModal} onSave={handleSave} editing={editing} saving={saving} simTypes={simTypes} />
    </>
  );
}
